export type UploadType = 'text' | 'image' | 'video' | 'pdf';

export class UploadUtils {
  static normalizeUploadTypes(uploadTypes: string | string[] | undefined): UploadType[] {
    if (Array.isArray(uploadTypes)) {
      return uploadTypes as UploadType[];
    }

    if (typeof uploadTypes === 'string') {
      return uploadTypes
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean) as UploadType[];
    }

    return ['text', 'image'];
  }
}
